module.exports = __webpack_public_path__ + "assets/img/69_213_3.3c904856.jpg";